/**
 * @license
 *
 * Copyright IBM Corp. 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { descriptor as parentDescriptor } from '../link-with-icon/link-with-icon.js';
import { propTypes as parentPropTypes } from '../link-with-icon/link-with-icon.js';
export { default as CustomElement } from '../../components/card/card-footer.js';
import createReactCustomElementType, {
  booleanSerializer,
} from '@carbon/web-components/es/globals/wrappers/createReactCustomElementType.js';
import PropTypes from 'prop-types';
import settings from 'carbon-components/es/globals/js/settings.js';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings.js';
var prefix = settings.prefix;
var ddsPrefix = ddsSettings.stablePrefix;
export var descriptor = Object.assign({}, parentDescriptor, {
  altAriaLabel: {},
  colorScheme: {
    attribute: 'color-scheme',
  },
  parentHref: {
    attribute: 'parent-href',
  },
  iconInline: {
    serialize: booleanSerializer,
  },
  slot: {},
});
export var propTypes = {
  /**
   * Alternative aria label if no text in footer.
   */
  altAriaLabel: PropTypes.string,
  /**
   * The color scheme.
   */
  colorScheme: PropTypes.string,
  /**
   * The `href` in parent `<dds-card>`.
   * `<dds-card>` sets this automatically.
   */
  parentHref: PropTypes.string,
  /**
   * Positions the icon inline with text when `true`
   */
  iconInline: PropTypes.bool,
  /**
   * The slot in parent `<dds-card>`.
   */
  slot: PropTypes.string,
};
const Component = createReactCustomElementType(
  ''.concat(ddsPrefix, '-card-footer'),
  descriptor
);
Component.propTypes = propTypes;
export default Component;
